import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectUiState } from '../../../../store/app.selectors';

import { DarkModeService } from '../../../../core/services/dark-mode.service';
import { uiInitialState } from '../../../shared/store/ui.reducer';
import { AppStateWithChat } from '../../../../modules/chat/store/chat.reducer';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'ngx-dark-mode-toggle',
  templateUrl: './dark-mode-toggle.component.html',
  styleUrls: ['./dark-mode-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DarkModeComponent extends BaseComponent {
  private store = inject(Store<AppStateWithChat>);
  private darkModeService = inject(DarkModeService);

  ui = toSignal(this.store.select(selectUiState), { initialValue: uiInitialState });
  isDarkMode = computed(() => this.ui().isDarkMode);

  toggleDarkmode(isActive: boolean) {
    this.darkModeService.toggleDarkmode(isActive);
  }
}
